export const MaintenancePage = () => (
  <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6" data-testid="maintenance-page">
    <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-4">Be Right Back</p>
    <h1 className="font-extrabold uppercase text-3xl sm:text-4xl tracking-tight mb-4 max-w-lg">We're Currently Performing Maintenance</h1>
    <p className="text-midnight-black/60 font-medium max-w-md">Stranger Sessions is briefly offline for scheduled maintenance. Please check back shortly.</p>
  </div>
);
